import React from 'react';
import './SearchTriggerButton.css';

export interface SearchTriggerButtonProps {
  /** Le panneau « Votre recherche » est-il ouvert ? */
  expanded: boolean;
  /** Déclenche l'ouverture/fermeture du panneau (géré par le parent). */
  onClick: () => void;
}

/**
 * Bouton d'appel « Votre recherche » (SPEC §3.1, §6.1).
 * Haut-droite de la cartographie. Mobile : icône seule ; tablet/desktop : libellé.
 * Peut être recouvert par le panneau qu'il ouvre (pas de z-index supérieur aux panneaux).
 */
export const SearchTriggerButton: React.FC<SearchTriggerButtonProps> = ({ expanded, onClick }) => {
  return (
    <button
      type="button"
      className="search-trigger"
      onClick={onClick}
      aria-expanded={expanded}
      aria-controls="search-panel"
    >
      <span className="search-trigger__icon" aria-hidden="true">
        <img src="/magnifier.svg" alt="" className="search-trigger__icon-img" />
      </span>
      <span className="search-trigger__label">Votre recherche</span>
    </button>
  );
};

export default SearchTriggerButton;
